import {defaultEnv} from './environment.default';
import {Environment} from './environment.interface';

export const prodEnv: Environment = {
  env: 'prod',
  language: defaultEnv.language,
  serviceWorker: 'service.worker.js'
};
